import type { PremiumInvitePublicConfig } from "@/lib/premiumInvitePublicConfig";
import { normalizePublicOutboundUrl } from "@/lib/telegramPublicInviteUrl";

/**
 * URL del canal Telegram **gratis** (admin Invitación premium → `free_telegram_url`, o env).
 * Misma regla que `/invitacion-premium` y que la home con `BioTemplatePremiumSimple`.
 */
export function resolvePremiumInviteFreeTelegramUrl(
  publicConfig: PremiumInvitePublicConfig | null | undefined,
): string | undefined {
  const fromAdmin = publicConfig?.free_telegram_url?.trim() ?? "";
  const fromEnv = (
    import.meta.env.VITE_PREMIUM_SIMPLE_FREE_TELEGRAM_URL as string | undefined
  )?.trim() ?? "";
  const merged = (fromAdmin || fromEnv).trim();
  const normalized = normalizePublicOutboundUrl(merged);
  return normalized || undefined;
}
